// extracted by mini-css-extract-plugin
export default {"button":"CreateEnquiryPage_button__V5sjL","radio":"CreateEnquiryPage_radio__uCrIw"};